import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';

// Global Selectors
// @ts-ignore
import { makeSelectTimesheetValue } from 'services/timesheets/selectors';

interface OwnProps {
    timesheetId: number;
}

interface ConnectedProps {
    personLastName?: string;
}

type Props = OwnProps & ConnectedProps;

export class TimesheetPersonLastNameValue extends React.PureComponent<Props> {
    render(): string | null {
        const { personLastName } = this.props;
        if (!personLastName) {
            return null;
        }
        return personLastName;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    personLastName: makeSelectTimesheetValue('personLastName')
});

export default connect(mapStateToProps)(TimesheetPersonLastNameValue);
